import React, { useCallback } from 'react'
import { Formik } from 'formik'
import { FormattedMessage as Lang } from 'react-intl'
import pt from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import TextField from '@/components/fields/TextField'
import TextAreaField from '@/components/fields/TextAreaField'
import LabelWithIcon from '@/components/blocks/LabelWithIcon'
import CheckBoxField from '@/components/fields/CheckBoxField'
import SelectField from '@/components/fields/SelectField'
import {
  ADMIN_NAME,
  ADMIN_SURNAME,
  ADMIN_PATRONYMIC,
  ADMIN_TELEPHON,
  ADMIN_EMAIL,
  ADMIN_POSITION,
  ADMIN_ABOUT_ME,
  ADMIN_PHOTO,
  ADMIN_BLOCK,
} from '@/constants/forms/admin'
import {
  FormWrapper,
  FieldsWrapper,
  InputAndLabelContainer,
  Label,
  Text,
} from './styles'

const TYPE = 'groupId'

const EditUserFromAdminForm = React.forwardRef(({
  formData,
  setDirty,
  tenantGroups,
  canEdit,
  isFormModifying,
}, ref) => {
  const handleSubmit = (values, form) => {
    // TODO: add handlers
  }
  const renderTextFiled = useCallback(({
    error,
    name,
    mask,
    fieldProps,
    cols,
    rows,
    charLimit,
    disabled,
    value,
  }) => {
    const regex = /(\d?)(\d{3})(\d{3})(\d{2})(\d{2})/g
    const phoneExample = '$1 ($2) $3-$4-$5'
    if (isFormModifying && name !== ADMIN_ABOUT_ME) {
      return (
        <TextField
          error={error}
          name={name}
          mask={mask}
          fieldProps={fieldProps}
          resetButton
        />
      )
    }
    if (name === ADMIN_TELEPHON && value) {
      return (
        <Text>
          {value.replace(regex, phoneExample)}
        </Text>
      )
    }
    if (name === ADMIN_ABOUT_ME && isFormModifying) {
      return (
        <TextAreaField
          name={ADMIN_ABOUT_ME}
          cols={cols}
          rows={rows}
          charLimit={charLimit}
          disabled={disabled}
          fieldProps={fieldProps}
        />
      )
    }
    return (
      <Text>
        {value}
      </Text>
    )
  }, [isFormModifying])
  return (
    <Formik
      ref={ref}
      initialValues={{
        [ADMIN_NAME]: formData[ADMIN_NAME] || '',
        [ADMIN_SURNAME]: formData[ADMIN_SURNAME] || '',
        [ADMIN_PATRONYMIC]: formData[ADMIN_PATRONYMIC] || '',
        [ADMIN_TELEPHON]: formData[ADMIN_TELEPHON] || '',
        [ADMIN_EMAIL]: formData[ADMIN_EMAIL] || '',
        [ADMIN_POSITION]: formData[ADMIN_POSITION] || '',
        [ADMIN_ABOUT_ME]: formData[ADMIN_ABOUT_ME] || '',
        [ADMIN_PHOTO]: formData[ADMIN_PHOTO] || null,
        [ADMIN_BLOCK]: formData[ADMIN_BLOCK] || false,
        [TYPE]: !isEmpty(formData && formData.group) ? formData.group.id : null,
      }}
      onSubmit={handleSubmit}
      render={({
        touched, errors, handleSubmit, dirty, values,
      }) => {
        setDirty(dirty)
        return (
          <FormWrapper onSubmit={handleSubmit} id="userData" name="userData">
            <FieldsWrapper>
              <InputAndLabelContainer>
                <LabelWithIcon
                  isError={(touched[ADMIN_SURNAME] && errors[ADMIN_SURNAME])}
                  title={(<Lang id="usersPage.editAdmin.surname" />)}
                  userForm
                />
                {renderTextFiled({
                  name: ADMIN_SURNAME,
                  fieldProps: {
                    pattern: '[a-zA-Zа-яА-Я]',
                    autoComplete: 'off',
                    disabled: true,
                  },
                  value: values[ADMIN_SURNAME],
                })}
              </InputAndLabelContainer>
              <InputAndLabelContainer>
                <LabelWithIcon
                  isError={(touched[ADMIN_NAME] && errors[ADMIN_NAME])}
                  title={(<Lang id="usersPage.editAdmin.name" />)}
                  userForm
                />
                {renderTextFiled({
                  name: ADMIN_NAME,
                  fieldProps: {
                    pattern: '[a-zA-Zа-яА-Я]',
                    autoComplete: 'off',
                    disabled: true,
                  },
                  value: values[ADMIN_NAME],
                })}
              </InputAndLabelContainer>
              <InputAndLabelContainer>
                <LabelWithIcon
                  isError={(touched[ADMIN_PATRONYMIC] && errors[ADMIN_PATRONYMIC])}
                  title={(<Lang id="usersPage.editAdmin.patronymic" />)}
                  userForm
                />
                {renderTextFiled({
                  name: ADMIN_PATRONYMIC,
                  fieldProps: {
                    pattern: '[a-zA-Zа-яА-Я]',
                    autoComplete: 'off',
                    disabled: true,
                  },
                  value: values[ADMIN_PATRONYMIC],
                })}
              </InputAndLabelContainer>
              <InputAndLabelContainer>
                <LabelWithIcon
                  isError={(touched[ADMIN_TELEPHON] && errors[ADMIN_TELEPHON])}
                  title={(<Lang id="usersPage.editAdmin.telephone" />)}
                  userForm
                />
                {renderTextFiled({
                  name: ADMIN_TELEPHON,
                  mask: '7-999-999-99-99',
                  fieldProps: {
                    pattern: '[0-9]',
                    autoComplete: 'off',
                    disabled: true,
                  },
                  value: values[ADMIN_TELEPHON],
                })}
              </InputAndLabelContainer>
              <InputAndLabelContainer>
                <LabelWithIcon
                  isError={(touched[ADMIN_EMAIL] && errors[ADMIN_EMAIL])}
                  title={(<Lang id="usersPage.editAdmin.email" />)}
                  userForm
                />
                {renderTextFiled({
                  name: ADMIN_EMAIL,
                  fieldProps: {
                    autoComplete: 'off',
                    disabled: true,
                  },
                  value: values[ADMIN_EMAIL],
                })}
              </InputAndLabelContainer>
              <InputAndLabelContainer>
                <LabelWithIcon
                  isError={(touched[ADMIN_POSITION] && errors[ADMIN_POSITION])}
                  title={(<Lang id="usersPage.editAdmin.position" />)}
                  userForm
                />
                {renderTextFiled({
                  name: ADMIN_POSITION,
                  fieldProps: {
                    pattern: '[a-zA-Zа-яА-Я ]',
                    autoComplete: 'off',
                    disabled: true,
                  },
                  value: values[ADMIN_POSITION],
                })}
              </InputAndLabelContainer>
              <InputAndLabelContainer>
                <LabelWithIcon
                  isError={(touched[ADMIN_ABOUT_ME] && errors[ADMIN_ABOUT_ME])}
                  title={(<Lang id="usersPage.editAdmin.aboutMe" />)}
                  userForm
                />
                {renderTextFiled({
                  name: ADMIN_ABOUT_ME,
                  cols: '40',
                  rows: '5',
                  charLimit: 256,
                  disabled: true,
                  fieldProps: {
                    autoComplete: 'off',
                  },
                  value: values[ADMIN_ABOUT_ME],
                })}
              </InputAndLabelContainer>
              {isFormModifying && (
                <>
                  <InputAndLabelContainer>
                    <LabelWithIcon
                      title={(<Lang id="usersPage.editAdmin.group" />)}
                      userForm
                    />
                    <SelectField
                      name={TYPE}
                      options={tenantGroups}
                      userForm
                    />
                  </InputAndLabelContainer>
                  <InputAndLabelContainer row>
                    <CheckBoxField name={ADMIN_BLOCK} marginRight />
                    <Label>
                      <Lang id="usersPage.editAdmin.block" />
                    </Label>
                  </InputAndLabelContainer>
                </>
              )}
            </FieldsWrapper>
          </FormWrapper>
        )
      }}
    />
  )
})

EditUserFromAdminForm.propTypes = {
  formData: pt.shape({
    [ADMIN_NAME]: pt.string,
    [ADMIN_SURNAME]: pt.string,
    [ADMIN_PATRONYMIC]: pt.string,
    [ADMIN_TELEPHON]: pt.string,
    [ADMIN_EMAIL]: pt.string,
    [ADMIN_POSITION]: pt.string,
    [ADMIN_ABOUT_ME]: pt.string,
  }),
}

EditUserFromAdminForm.defaultProps = {
  formData: {
    [ADMIN_NAME]: '',
    [ADMIN_SURNAME]: '',
    [ADMIN_PATRONYMIC]: '',
    [ADMIN_TELEPHON]: '',
    [ADMIN_EMAIL]: '',
    [ADMIN_POSITION]: '',
    [ADMIN_ABOUT_ME]: '',
  },
}

export default React.memo(EditUserFromAdminForm)
